import { Link } from "react-router-dom";
import { TableToolbar } from "@/components/ui/table-toolbar";
import { TableSearchInput } from "@/components/ui/table-search-input";
import { SortDropdown } from "@/components/ui/sort-dropdown.js";
import {
  SCENARIO_SORT_OPTIONS,
  type ScenarioSortKey,
} from "./scenarios-tab-types";

interface ScenariosToolbarProps {
  projectId: string;
  scenarioCount: number;
  searchQuery: string;
  onSearchChange: (val: string) => void;
  sortKey: ScenarioSortKey;
  onSortChange: (val: ScenarioSortKey) => void;
  hasActiveFilters: boolean;
  onResetFilters: () => void;
}

export function ScenariosToolbar({
  projectId,
  scenarioCount,
  searchQuery,
  onSearchChange,
  sortKey,
  onSortChange,
  hasActiveFilters,
  onResetFilters,
}: ScenariosToolbarProps) {
  return (
    <TableToolbar
      hasActiveFilters={hasActiveFilters}
      onResetFilters={onResetFilters}
      count={
        <span>
          <strong className="text-foreground">{scenarioCount}</strong> scenario
          {scenarioCount !== 1 ? "s" : ""}
        </span>
      }
      actions={
        <div className="flex items-center gap-3">
          <Link
            to={`/projects/${projectId}/walkthroughs`}
            className="inline-flex items-center gap-1.5 text-xs text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline"
          >
            Run history →
          </Link>
          <SortDropdown
            options={SCENARIO_SORT_OPTIONS}
            value={sortKey}
            onChange={onSortChange}
          />
        </div>
      }
    >
      <TableSearchInput
        placeholder="Search scenarios..."
        value={searchQuery}
        onChange={onSearchChange}
        ariaLabel="Search scenarios"
      />
    </TableToolbar>
  );
}
